export default __webpack_public_path__ + "static/media/github-sign.ae3517cc.webp";